import type { ReportRoadmapBodyReason } from './reportRoadmapBodyReason';

export type ReportRoadmapBody = {
  /**
   * 상세 설명 (선택)
   * @maxLength 500
   */
  description?: string;
  /** 신고 사유 */
  reason: ReportRoadmapBodyReason;
};
